import { NoResultsCard } from '@apps-common/components/common'
import { INPUT_INFO_SM_NO_BORDER, InputInfoSM } from '@apps-common/components/elements'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { useManagementUnitSelectItems } from '@apps-common/hooks/useManagementUnitSelectItems'
import { IUnitSimActiveModel } from '@apps-common/types/management/unit'

export const UnitsAddedModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: {
    addedDevices: IUnitSimActiveModel[]
  }
}) => {
  const { addedDevices } = componentProps
  const { companies, plans } = useManagementUnitSelectItems()

  return (
    <ModalContainer alwaysMobile>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader title='Added Devices' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>

      <ModalBody classes='!pt-[100px]'>
        <div className='flex flex-col gap-4'>
          {addedDevices &&
            addedDevices.length > 0 &&
            addedDevices.reverse().map((d, i) => {
              const deviceNo = addedDevices.length - i
              const mc = companies?.options?.find((c) => c.value === d.monitoringCentreId)
              const bu = companies?.options?.find((c) => c.value === d.bureauId)
              const tc = companies?.options?.find((c) => c.value === d.techCompanyId)
              const plan = plans?.options?.find((p) => p.value === d.unitPlanId)

              return (
                <div>
                  <div key={`create-multiple-devices-${d.unitId}-${i}`} className='relative bg-secondary-content/5 p-4 rounded-xl'>
                    <div className='bg-secondary-content/20 px-4 py-2 rounded-full text-[0.85rem] leading-[0.85rem] mb-[15px] inline-block'>
                      Device {deviceNo}
                    </div>
                    <div className='grid grid-cols-2'>
                      <InputInfoSM
                        id='monitoringCentre'
                        label='Monitoring Centre'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={mc?.label || 'None assigned'}
                      />
                      <InputInfoSM
                        id='bureau'
                        label='Bureau'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={bu?.label || 'None assigned'}
                      />
                      <InputInfoSM
                        id='technician'
                        label='Technician'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={tc?.label || 'None assigned'}
                      />
                      <InputInfoSM
                        id='plan'
                        label='Plan'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={plan?.label || 'None assigned'}
                      />
                      <InputInfoSM
                        id='mobileNo'
                        label='Mobile No'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.mobileNo || 'None assigned'}
                      />
                      <InputInfoSM
                        id='simNo'
                        label='Sim No'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.simNo || 'None assigned'}
                      />
                      <InputInfoSM
                        id='ipAddress'
                        label='IP Address'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.ip || 'None assigned'}
                      />
                      <InputInfoSM
                        id='serialNo'
                        label='Serial No'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.serialNo || 'None assigned'}
                      />
                      <InputInfoSM
                        id='imei'
                        label='IMEI'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.imei || 'None assigned'}
                      />
                      <InputInfoSM
                        id='lineSupervision'
                        label='Line Supervision'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.lineSupervision ? 'Enabled' : 'Disabled'}
                      />
                      <InputInfoSM
                        id='activated'
                        label='Activated'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.isActivated ? 'Yes' : 'No'}
                      />
                      <InputInfoSM
                        id='toBeInvoiced'
                        label='To Be Invoiced'
                        showLabel
                        labelClassName='ml-0 mb-1 rounded-sm jost-medium'
                        className={INPUT_INFO_SM_NO_BORDER}
                        hideNoEditIcon
                        value={d.hardwareToBeInvoiced ? 'Yes' : 'No'}
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          {(!addedDevices || addedDevices.length === 0) && <NoResultsCard>No devices have been added this session.</NoResultsCard>}
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
